import {
  Show,
  SimpleShowLayout,
  TextField,
  RichTextField,
  BooleanField,
  DateField
} from 'react-admin';

const ExamTypeShow = () => (
  <Show
    title="Tipo de Exame">
    <SimpleShowLayout>
      <TextField source="id"/>
      <TextField source="exam_group.short_name" label="Grupo" />
      <TextField source="type_reference.symbol" label="Referência" />
      <TextField source="gender.name" label="Gênero" />
      <TextField source="name" label="Nome" />
      <TextField source="initial_reference_value" label="Valor Inicial" />
      <TextField source="final_reference_value" label="Valor Final" />
      <TextField source="ideal_value" label="Valor Ideal" />
      <TextField source="min_value" label="Valor Mínimo" />
      <TextField source="max_value" label="Valor Máximo" />
      <TextField source="min_red_left_value" label="Mínimo Vermelho Esquerda" />
      <TextField source="max_red_left_value" label="Máximo Vermelho Esquerda" />
      <TextField source="min_orange_left_value" label="Mínimo Laranja Esquerda" />
      <TextField source="max_orange_left_value" label="Máximo Laranja Esquerda" />
      <TextField source="min_yellow_left_value" label="Mínimo Amarelo Esquerda" />
      <TextField source="max_yellow_left_value" label="Máximo Amarelo Esquerda" />
      <TextField source="min_green_value" label="Mínimo Verde" />
      <TextField source="max_green_value" label="Máximo Verde" />
      <TextField source="min_yellow_right_value" label="Mínimo Amarelo Direita" />
      <TextField source="max_yellow_right_value" label="Máximo Amarelo Direita" />
      <TextField source="min_orange_right_value" label="Mínimo Laranja Direita" />
      <TextField source="max_orange_right_value" label="Máximo Laranja Direita" />
      <TextField source="min_red_right_value" label="Mínimo Vermelho Direita" />
      <TextField source="max_red_right_value" label="Máximo Vermelho Direita" />
      <RichTextField source="description" label="Descrição" />
      <BooleanField source="active" label="Ativo" />
      <DateField source="created_at" locales="pt-BR" label="Criado em" showTime />
    </SimpleShowLayout>
  </Show>
);

export default ExamTypeShow;
